(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-hero-subscribe"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('campaign-hero-background')) {
    customElements.define('campaign-hero-background', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.desktop = window.matchMedia('(min-width: 769px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.started = new Set();
        this.inView = false;
        this.onChange = () => this.updateVideo();
        this.onPlaying = () => this.video.classList.add('is-playing');
        this.onFailure = () => this.video.classList.remove('is-playing');
        this.video.addEventListener('playing', this.onPlaying);
        this.video.addEventListener('error', this.onFailure);
        this.desktop.addEventListener('change', this.onChange);
        this.reducedMotion.addEventListener('change', this.onChange);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          if (this.inView) this.updateVideo();
        });
        this.observer.observe(this);
        this.updateVideo();
      }

      updateVideo() {
        const device = this.desktop.matches ? 'desktop' : 'mobile';
        if (this.device !== device || this.reducedMotion.matches) {
          this.video.pause();
          this.video.classList.remove('is-playing');
          this.video.replaceChildren();
          this.video.removeAttribute('src');
          this.video.load();
          this.device = device;
        }
        if (!this.inView || this.reducedMotion.matches || this.started.has(device)) return;
        const sources = this.querySelector(`[data-${device}]`).content;
        if (!sources.querySelector('source')) return;
        this.started.add(device);
        this.video.muted = true;
        this.video.append(sources.cloneNode(true));
        this.video.load();
        this.video.play().catch(() => {
          if (this.device === device) this.onFailure();
        });
      }

      disconnectedCallback() {
        this.observer.disconnect();
        this.desktop.removeEventListener('change', this.onChange);
        this.reducedMotion.removeEventListener('change', this.onChange);
        this.video.pause();
        this.video.removeEventListener('playing', this.onPlaying);
        this.video.removeEventListener('error', this.onFailure);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
